import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_female_pre_paywall_copy~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_female_pre_paywall_copy'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_female_pre_paywall_copy~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_female_pre_paywall_copy'),
			},
		},
	},
]

export default config
